import { LanguageKey } from '@models/common';
import { createSlice } from '@reduxjs/toolkit';

export interface IPreferencesState {
  language: LanguageKey;
  theme: 'light' | 'dark';
}

const initialState: IPreferencesState = {
  language: 'jaJP',
  theme: 'light',
};

export const preferencesSlice = createSlice({
  name: 'preferencesSlice',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      localStorage.setItem('language', action.payload);
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
  },
});

export const { setLanguage, setTheme } = preferencesSlice.actions;

export default preferencesSlice.reducer;
